<template>
  <b-row>
    <b-col cols="12" lg="8">
      <b-card header="Informações Básicas">
        <b-card-body>
          <b-form no-validate>
            <b-row>
              <b-col cols="12" lg="9">
                <b-form-group :label="i18n.fantasyName">
                  <b-form-input
                    v-model="company.fantasyName"
                    type="text"
                    class="form-control"
                    disabled
                  ></b-form-input>
                </b-form-group>
              </b-col>
              <b-col cols="12" lg="3">
                <b-form-group :label="i18n.cnpj">
                  <b-form-input
                    ref="cnpj"
                    v-model="company.cnpj"
                    v-mask="'##.###.###/####-##'"
                    type="text"
                    class="form-control"
                    disabled
                  ></b-form-input>
                </b-form-group>
              </b-col>
            </b-row>
            <b-row>
              <b-col cols="12" lg="9">
                <b-form-group :label="i18n.companyName">
                  <b-form-input
                    v-model="company.name"
                    type="text"
                    class="form-control"
                    disabled
                  ></b-form-input>
                </b-form-group>
              </b-col>
              <b-col cols="12" lg="3">
                <b-form-group :label="i18n.inscricaoMunicipal">
                  <b-form-input
                    v-model="company.municipalRegister"
                    type="text"
                    class="form-control"
                    disabled
                  ></b-form-input>
                </b-form-group>
              </b-col>
            </b-row>
            <b-row>
              <b-col cols="12" lg="3">
                <b-form-group :label="i18n.hqPhone">
                  <b-form-input
                    ref="phone"
                    v-model="company.phone"
                    v-mask="['(##) ####-####', '(##) #####-####']"
                    type="tel"
                    class="form-control"
                    disabled
                  ></b-form-input>
                </b-form-group>
              </b-col>
              <b-col cols="12" lg="3">
                <b-form-group :label="i18n.field">
                  <b-form-input
                    v-model="company.field"
                    type="text"
                    class="form-control"
                    disabled
                  ></b-form-input>
                </b-form-group>
              </b-col>
              <b-col cols="12" lg="3">
                <b-form-group :label="i18n.porte">
                  <b-form-select
                    v-model="company.size"
                    class="form-control"
                    :options="companySizeOpts"
                    disabled
                  ></b-form-select>
                </b-form-group>
              </b-col>
              <b-col cols="12" lg="3">
                <b-form-group label="">
                  <b-form-checkbox
                    v-model="company.optSimples"
                    class="mb-auto"
                    :value="true"
                    :unchecked-value="false"
                    disabled
                    >Optante pelo Simples
                  </b-form-checkbox>
                </b-form-group>
              </b-col>
            </b-row>
            <hr />
            <b-row>
              <b-col cols="12" lg="6">
                <b-form-group :label="i18n.address">
                  <b-form-textarea
                    v-model="company.address"
                    type="text"
                    class="form-control"
                    :rows="2"
                    :max-rows="2"
                    disabled
                  ></b-form-textarea>
                </b-form-group>
              </b-col>
              <b-col cols="12" lg="3">
                <b-form-group :label="i18n.state">
                  <b-form-select
                    v-model="company.state"
                    class="form-control"
                    :options="statesOpts"
                    disabled
                  ></b-form-select>
                </b-form-group>
              </b-col>
              <b-col cols="12" lg="3">
                <b-form-group :label="i18n.city">
                  <b-form-select
                    v-model="company.city"
                    class="form-control"
                    :options="citiesOpts"
                    disabled
                  ></b-form-select>
                </b-form-group>
              </b-col>
            </b-row>
            <b-row>
              <b-col cols="12" lg="3">
                <b-form-group :label="i18n.zipCode">
                  <b-form-input
                    ref="zipCode"
                    v-model="company.zipCode"
                    v-mask="'#####-###'"
                    class="form-control"
                    disabled
                  ></b-form-input>
                </b-form-group>
              </b-col>
            </b-row>
          </b-form>
        </b-card-body>
      </b-card>

      <b-card header="Informações Financeiras">
        <b-card-body>
          <b-form no-validate>
            <b-row>
              <b-col cols="12" lg="4">
                <b-form-group :label="i18n.responsavelFinanceiro">
                  <b-form-input
                    v-model="company.financial.accountable.name"
                    type="text"
                    class="form-control"
                    disabled
                  ></b-form-input>
                </b-form-group>
              </b-col>
              <b-col cols="12" lg="4">
                <b-form-group :label="i18n.financePhone">
                  <b-form-input
                    ref="financePhone"
                    v-model="company.financial.accountable.phone"
                    v-mask="['(##) ####-####', '(##) #####-####']"
                    type="tel"
                    class="form-control"
                    disabled
                  ></b-form-input>
                </b-form-group>
              </b-col>
              <b-col cols="12" lg="4">
                <b-form-group :label="i18n.emailFinanceiro">
                  <b-form-input
                    v-model="company.financial.accountable.email"
                    type="email"
                    class="form-control"
                    disabled
                  ></b-form-input>
                </b-form-group>
              </b-col>
            </b-row>
            <b-row>
              <b-col cols="12" lg="4">
                <b-form-group :label="i18n.emailNotaFiscal">
                  <b-form-input
                    v-model="company.financial.invoiceEmail"
                    type="email"
                    class="form-control"
                    disabled
                  ></b-form-input>
                </b-form-group>
              </b-col>
            </b-row>
          </b-form>
        </b-card-body>
      </b-card>

      <b-card header="Compliance - Canal de Comunicações">
        <b-card-body>
          <b-form no-validate>
            <b-row>
              <b-col cols="12" lg="4">
                <b-form-group :label="i18n.coName">
                  <b-form-input
                    v-model="company.compliance.accountable.name"
                    type="text"
                    class="form-control"
                    disabled
                  ></b-form-input>
                </b-form-group>
              </b-col>
              <b-col cols="12" lg="4">
                <b-form-group :label="i18n.coPosition">
                  <b-form-input
                    v-model="company.compliance.accountable.position"
                    type="text"
                    class="form-control"
                    disabled
                  ></b-form-input>
                </b-form-group>
              </b-col>
              <b-col cols="12" lg="4">
                <b-form-group :label="i18n.coSector">
                  <b-form-select
                    v-model="company.compliance.accountable.sector"
                    class="form-control"
                    :options="sectorOptions"
                    disabled
                  ></b-form-select>
                </b-form-group>
              </b-col>
              <b-col cols="12" lg="4">
                <b-form-group :label="i18n.coPhone">
                  <b-form-input
                    ref="coPhone"
                    v-model="company.compliance.accountable.phone"
                    v-mask="['(##) ####-####', '(##) #####-####']"
                    type="text"
                    class="form-control"
                    disabled
                  ></b-form-input>
                </b-form-group>
              </b-col>
              <b-col cols="12" lg="4">
                <b-form-group :label="i18n.coEmail">
                  <b-form-input
                    v-model="company.compliance.accountable.email"
                    type="email"
                    class="form-control"
                    disabled
                  ></b-form-input>
                </b-form-group>
              </b-col>
            </b-row>
            <b-row>
              <b-col>
                <b-form-group :label="i18n.coObservation">
                  <b-form-textarea
                    v-model="company.compliance.observation"
                    :rows="3"
                    :max-rows="6"
                    disabled
                  >
                  </b-form-textarea>
                </b-form-group>
              </b-col>
            </b-row>
            <b-row>
              <b-col cols="12" lg="4">
                <b-form-group :label="i18n.complianceEmail">
                  <b-form-input
                    v-model="company.compliance.email"
                    type="text"
                    class="form-control"
                    disabled
                  ></b-form-input>
                </b-form-group>
              </b-col>
              <b-col cols="12" lg="4">
                <b-form-group :label="i18n.compliancePhone">
                  <b-form-input
                    ref="compliancePhone"
                    v-model="company.compliance.phone"
                    v-mask="['(##) ####-####', '(##) #####-####']"
                    type="text"
                    class="form-control"
                    disabled
                  ></b-form-input>
                </b-form-group>
              </b-col>
            </b-row>
            <b-row>
              <b-col>
                <b-form-group :label="i18n.proceduresNotes">
                  <b-form-textarea
                    v-model="company.compliance.proceduresNotes"
                    :rows="3"
                    :max-rows="6"
                    disabled
                  >
                  </b-form-textarea>
                </b-form-group>
              </b-col>
            </b-row>
          </b-form>
        </b-card-body>
      </b-card>
      <b-card header="Recebimento de denúncias por meio de telefone">
        <b-card-body>
          <b-form no-validate>
            <b-row>
              <b-col cols="12" lg="4">
                <b-form-group label="">
                  <b-form-checkbox
                    v-model="company.phoneService.hasService"
                    class="mb-auto"
                    :value="true"
                    :unchecked-value="false"
                    disabled
                    >Possui serviços de recepção de denúncias por meio
                    telefônico?
                  </b-form-checkbox>
                </b-form-group>
              </b-col>
              <b-col cols="12" lg="4">
                <b-form-group label="">
                  <b-form-checkbox
                    v-model="company.phoneService.allocatedWithUs"
                    class="mb-auto"
                    :value="true"
                    :unchecked-value="false"
                    disabled
                    >O serviço está alocado na Conformità?
                  </b-form-checkbox>
                </b-form-group>
              </b-col>
              <b-col cols="12" lg="4">
                <b-form-group label="">
                  <b-form-checkbox
                    v-model="company.phoneService.shared"
                    class="mb-auto"
                    :value="true"
                    :unchecked-value="false"
                    disabled
                    >O serviço é compartilhado?
                  </b-form-checkbox>
                </b-form-group>
              </b-col>
            </b-row>
            <b-row>
              <b-col cols="12" lg="4">
                <b-form-group :label="i18n.phoneSerivcePhone">
                  <b-form-input
                    ref="phoneServicePhone"
                    v-model="company.phoneService.phone"
                    v-mask="['(##) ####-####', '(##) #####-####']"
                    type="text"
                    class="form-control"
                    disabled
                  ></b-form-input>
                </b-form-group>
              </b-col>
              <b-col cols="12" lg="4">
                <b-form-group :label="i18n.phoneSerivceCode">
                  <b-form-input
                    v-model="company.phoneService.code"
                    type="text"
                    class="form-control"
                    disabled
                  ></b-form-input>
                </b-form-group>
              </b-col>
            </b-row>
            <b-row>
              <b-col cols="12" lg="8">
                <b-form-group :label="i18n.phoneSerivceObs">
                  <b-form-textarea
                    v-model="company.phoneService.observation"
                    type="text"
                    class="form-control"
                    :rows="2"
                    :max-rows="2"
                    disabled
                  ></b-form-textarea>
                </b-form-group>
              </b-col>
            </b-row>
          </b-form>
        </b-card-body>
      </b-card>
    </b-col>
    <a
      ref="download"
      class="invisible"
      target="_blank"
      :download="download.name"
      :href="download.link"
    ></a>
  </b-row>
</template>

<script>
import {
  getCompany,
  getCompanySize,
  getClassificationValues,
} from "../../api/company";
import { getStates, getCities } from "../../api/geo";
import { ValidatorDictionary } from "../../i18n";

import { mapGetters } from "vuex";

import { mask } from "vue-the-mask";

export default {
  name: "MyCompany",
  directives: { mask },
  data() {
    return {
      i18n: ValidatorDictionary.attributes,
      download: {
        name: null,
        link: null,
      },
      loading: false,
      company: {
        phoneService: {},
        financial: {
          accountable: {},
        },
        compliance: {
          accountable: {},
          files: {},
        },
      },
      states: [],
      cities: [],
      companySize: [],
      sectors: [],
    };
  },
  computed: {
    ...mapGetters(["profile", "portalBucket"]),
    companiesOpts() {
      const opts = [];
      for (const company of this.companies) {
        opts.push({ value: company._id, text: company.name });
      }
      return opts;
    },
    statesOpts() {
      const opts = [];
      for (const state of this.states) {
        opts.push({ value: state._id, text: state.name });
      }
      return opts;
    },
    citiesOpts() {
      const opts = [];
      for (const city of this.cities) {
        opts.push({ value: city.code, text: city.name });
      }
      return opts;
    },
    companySizeOpts() {
      const opts = [];
      opts.push({ value: undefined, text: "Não especificado" });
      for (const size of this.companySize) {
        opts.push({ value: size._id, text: size.name });
      }
      return opts;
    },
    hasSectors() {
      return this.sectors.length > 0;
    },
    sectorOptions() {
      const opts = [
        {
          value: "",
          text: this.hasSectors
            ? "Por favor selecione um setor"
            : "Nenhum setor cadastrado",
          disabled: true,
        },
      ];

      for (const sector of this.sectors) {
        opts.push({ value: sector, text: sector });
      }

      return opts;
    },
  },
  async created() {
    const id = this.profile.company;

    await this.loadStates();
    await this.loadCompanySize();
    await this.loadSectors(id);

    const response = await getCompany(id);
    const company = response.data;
    this.loadCities(company.state);

    company.phoneService = company.phoneService || {};

    company.financial = company.financial || {};
    company.financial.accountable = company.financial.accountable || {};

    company.compliance = company.compliance || {};
    company.compliance.accountable = company.compliance.accountable || {};

    const currentSector = company?.compliance?.accountable?.sector;
    if (currentSector && !this.sectors.includes(String(currentSector).trim())) {
      company.compliance.accountable.sector = "";
    }

    this.company = company;
    const updateEls = [
      "cnpj",
      "phone",
      "financePhone",
      "zipCode",
      "coPhone",
      "compliancePhone",
      "phoneServicePhone",
    ];
    this.$nextTick(() => {
      for (const id of updateEls) {
        this.$refs[id].$el.oninput({ isTrusted: true });
      }
    });
  },
  methods: {
    goBack() {
      this.$router.go(-1);
    },

    async loadStates() {
      const response = await getStates();
      this.states = response.data;
    },
    async loadCompanySize() {
      const response = await getCompanySize();
      this.companySize = response.data;
    },
    async loadSectors(companyId) {
      try {
        const response = await getClassificationValues(companyId, 7);
        this.sectors = (response.data || [])
          .map((item) => (item?.value || "").trim())
          .filter(Boolean);
      } catch (error) {
        this.sectors = [];
      }
    },
    async loadCities(state) {
      const response = await getCities(state);
      this.cities = response.data;
    },
    async refreshCities(state) {
      this.company.city = undefined;
      await this.loadCities(state);
    },
  },
};
</script>
